import { Component } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { AppComponent } from 'src/app/app.component';
import { BannerService } from 'src/app/service/bannerService.service';
import { aplicarFiltrosConsulta, isFiltroIdNumerico } from 'src/app/util/consulta/wow-consulta.util';
import { Utils } from 'src/app/util/utils';
import { BannerWowGo } from './banner';

@Component({
  selector: 'app-banner-consulta',
  templateUrl: './banner-consulta.component.html',
  styleUrls: [
    './banner-shared.scss',
    '../../util/conta-financeira/conta-financeira-consulta.scss',
  ],
})
export class BannerConsultaComponent {

  banners: BannerWowGo[] = [];
  ordemColunasTabela: string[] = ['id', 'descricao', 'dataInicio', 'dataTermino', 'nomeArquivo', 'ativo', 'acoes'];
  totalElementos = 0;
  pagina = 0;
  tamanho = 5;
  pageSizeOptions: number[] = [5, 10, 15, 100];
  tipoFiltro = 'ID';
  parametro = '';
  situacao: boolean | null = null;
  consultaRealizada = false;
  tipoFiltros = ['ID', 'Descrição'];

  constructor(
    private bannerService: BannerService,
    private snackBar: MatSnackBar,
    private router: Router,
    private util: Utils,
    private appComponent: AppComponent,
  ) { }

  private temFiltro(): boolean {
    return !!this.parametro?.trim() || this.situacao !== null;
  }

  consultar(resetPagina = true) {
    if (resetPagina) {
      this.pagina = 0;
    }

    const idFiltro = isFiltroIdNumerico(this.tipoFiltro, this.parametro);
    if (idFiltro != null) {
      this.appComponent.mostrarLoading();
      this.bannerService.consultarPorId(idFiltro).subscribe(banner => {
        const lista = aplicarFiltrosConsulta(banner ? [banner] : [], this.tipoFiltro, this.parametro, this.situacao, {
          id: (b: BannerWowGo) => b.id,
          nome: (b: BannerWowGo) => b.descricao,
          ativo: (b: BannerWowGo) => b.ativo === true,
        });
        this.preencher(lista);
        this.totalElementos = lista.length;
        this.consultaRealizada = true;
      }, () => {
        this.snackBar.open('Banner não encontrado.', 'ERRO', { duration: 2500 });
      }).add(() => this.appComponent.fecharLoading());
      return;
    }

    const filtrando = this.temFiltro();
    const page = filtrando ? 0 : this.pagina;
    const size = filtrando ? 500 : this.tamanho;

    this.appComponent.mostrarLoading();
    this.bannerService.listarBanners(page, size).subscribe(response => {
      const conteudo: BannerWowGo[] = response?.content ?? [];
      const filtrados = aplicarFiltrosConsulta(conteudo, this.tipoFiltro, this.parametro, this.situacao, {
        id: (b: BannerWowGo) => b.id,
        nome: (b: BannerWowGo) => b.descricao,
        ativo: (b: BannerWowGo) => b.ativo === true,
      });
      this.preencher(filtrados);
      this.totalElementos = filtrando ? filtrados.length : (response?.totalElements ?? filtrados.length);
      this.pagina = filtrando ? 0 : (response?.number ?? this.pagina);
      this.consultaRealizada = true;
    }, () => {
      this.snackBar.open('Erro ao consultar banners.', 'ERRO', { duration: 2500 });
    }).add(() => this.appComponent.fecharLoading());
  }

  private preencher(lista: BannerWowGo[]) {
    lista.forEach(b => {
      b.dataInicio = this.util.formatarDateTimeParaData(b.dataInicio);
      b.dataTermino = this.util.formatarDateTimeParaData(b.dataTermino);
    });
    this.banners = lista;
  }

  paginar(event: PageEvent) {
    if (this.temFiltro()) {
      return;
    }
    this.pagina = event.pageIndex;
    this.tamanho = event.pageSize;
    this.consultar(false);
  }

  novo() {
    this.router.navigate(['/banner/form']);
  }

  editar(id: number) {
    this.router.navigate(['/banner/form', id]);
  }

  deletar(id: number) {
    if (!confirm('Excluir este banner?')) {
      return;
    }
    this.bannerService.deletar(id).subscribe(() => {
      this.snackBar.open('Banner deletado com sucesso!', 'Ok!', { duration: 2000 });
      this.consultar(false);
    }, () => {
      this.snackBar.open('Erro ao deletar banner.', 'Fechar!', { duration: 2000 });
    });
  }
}
